import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { MatMenuModule } from '@angular/material/menu';

import { TranslocoRootModule } from '@eai-tdv/core/transloco';

import {
  BtnV2Component,
  BtnV2SegmentGroupComponent,
} from '@eai-tdv/shared/components/btn-v2';
import {
  IconSvgDescSortingSmallComponent,
  IconSvgUpdateSyncComponent,
} from '@eai-tdv/shared/icon-svg';
import { TooltipDirective } from '@eai-tdv/shared/tooltip';

import { AppVersionWatchService } from '../app-version-watch.service';

@Component({
  standalone: true,
  imports: [
    MatMenuModule,
    TranslocoRootModule,
    BtnV2Component,
    BtnV2SegmentGroupComponent,
    IconSvgDescSortingSmallComponent,
    IconSvgUpdateSyncComponent,
    TooltipDirective,
  ],
  selector: 'tdv-version-available-popup',
  templateUrl: './version-available-popup.component.html',
  styleUrls: ['./version-available-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersionAvailablePopupComponent {
  appVersionWatchS = inject(AppVersionWatchService);

  msg = 'Refresh app to get the latest updates';
  updateMenuOpen = false;

  public onClose(): void {
    this.appVersionWatchS.closePopup();
  }

  public onReload(): void {
    window.location.reload();
  }
}
